import { useLayoutEffect, useState } from 'preact/hooks';

export function useVideoRatio(videoSlot: HTMLVideoElement): number {
  const [videoRatio, setVideoRatio] = useState(0);
  useLayoutEffect(() => {
    const onLoadedMetadata = () => setVideoRatio(videoSlot.videoWidth / videoSlot.videoHeight);
    videoSlot.addEventListener('loadedmetadata', onLoadedMetadata);
    return () => videoSlot.removeEventListener('loadedmetadata', onLoadedMetadata);
  }, []);
  return videoRatio;
}
